import React, { useState } from "react";
import axios from "axios";
import img from "../../assets/images/list_you_property_banner.jpg";
import BottomNav from "../../component/BottomNav";
import { Helmet } from 'react-helmet';
import { API_URL } from "../../common/constant";

// Modal Component
const Modal = ({ message, onClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50">
      <div className="bg-white p-8 rounded-2xl shadow-2xl max-w-md w-full text-center transform transition-all duration-300 scale-100 hover:scale-105">
        <p className="text-2xl font-semibold text-gray-800 mb-6">{message}</p>
        <button
          onClick={onClose}
          className="mt-6 bg-[#54BD95] text-white py-3 px-10 rounded-full hover:bg-[#4BAF7D] transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none"
        >
          Close
        </button>
      </div>
    </div>
  );
};

const Rent_Form = () => {
  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    location: "",
    message: "",
    propertyType: "",
    propertyImages: [],
  });

  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showModal, setShowModal] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = async (e) => {
    const files = e.target.files;
    const base64Images = await Promise.all(
      Array.from(files).map((file) => convertToBase64(file))
    );
    setFormData({ ...formData, propertyImages: base64Images });
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMessage("");
    setErrorMessage("");

    // Form validation check
    const { name, phoneNumber, email, location, message, propertyType, propertyImages } = formData;
    if (!name || !phoneNumber || !email || !location || !message || !propertyType || propertyImages.length === 0) {
      setErrorMessage("All fields are required.");
      setLoading(false);
      return;
    }

    try {
      const payload = {
        name,
        phoneNumber,
        email,
        location,
        message,
        propertyType,
        propertyImages,
      };

      const response = await axios.post(`${API_URL}/api/list-property/add`, payload);

      setSuccessMessage("Property listed successfully!");
      setFormData({
        name: "",
        phoneNumber: "",
        email: "",
        location: "",
        message: "",
        propertyType: "",
        propertyImages: [],
      });

      // Show modal
      setShowModal(true);
    } catch (error) {
      setErrorMessage(
        error.response?.data?.message || "Failed to list the property. Try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div>
      <Helmet>
        <title>List Your Property for Free | Rent & Sell in Lucknow</title>
        <meta name="description" content="List your property for free on Placezio Estate. Rent or sell your flats, apartments, and houses in Lucknow with ease. Get maximum exposure for your property today!" />
        <meta name="keywords" content="list property in Lucknow, rent property, sell house, apartments for rent, real estate Lucknow, free property listing" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Placezio Estate" />
      </Helmet>


      <div className="flex flex-col md:flex-row items-center  bg-cover bg-center px-4"
        style={{ backgroundImage: `url(${img})` }}
      >
        <div className="w-full md:w-1/2 p-4 md:p-12 rounded-2xl   ">
          <div className="mx-4">
            <h1 className="md:text-6xl text-3xl font-bold text-white mb-6">List Your Property<br>
            </br> for Free</h1>
            <p className="text-lg text-white">
              List your property in minutes and reach a wide audience of potential renters or buyers. It's quick, simple, and completely free!
            </p>

          </div>
        </div>

        <div className="w-1/1md:w-2/4 bg-white p-6 md:p-8 rounded-2xl shadow-xl mb-2 h-auto mt-2">
          <form onSubmit={handleSubmit} className="space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-gray-700 font-medium mb-1">Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder="Enter your name"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-1">Phone Number</label>
                <input
                  type="text"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleInputChange}
                  placeholder="Enter your phone number"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-gray-700 font-medium mb-1">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="Enter your email"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-1">Location</label>
                <input
                  type="text"
                  name="location"
                  value={formData.location}
                  onChange={handleInputChange}
                  placeholder="Enter your location"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-gray-700 font-medium mb-1">Property Type</label>
                <input
                  type="text"
                  name="propertyType"
                  value={formData.propertyType}
                  onChange={handleInputChange}
                  placeholder="Enter the property type"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-1">Upload Images</label>
                <input
                  type="file"
                  name="propertyImages"
                  onChange={handleFileChange}
                  multiple
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  required
                />
              </div>
            </div>

            <div>
              <label className="block text-gray-700 font-medium mb-1">Message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                placeholder="Enter your message"
                rows="4"
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                required
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full bg-[#54BD95] text-white font-medium py-2 px-4 rounded-lg hover:bg-[#4BAF7D] transition duration-200"
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </form>
        </div>

        {/* Modal */}
        {showModal && <Modal message="Property listed successfully!" onClose={closeModal} />}
      </div>
      <div className="">
        <BottomNav />
      </div>
    </div>
  );
};

export default Rent_Form;
